import { useRouter } from 'next/router';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { fetchGetRecordsTireFitting, getIsErrorUserRecord, getIsLoadedUserRecord, getRecordService } from '@entities/Services';
import { useWindowSizing } from '@hooks/useSizeWindow';
import { useCallback, useEffect } from 'react';
import { Badge, BadgeTheme, Button, ButtonSize, ButtonThemes, MyLink, SkeletonLoading, WrapperErrorLkShort, WrapperLk } from '@app/shared';
import { IconChevronRight } from '@koleso-icons';
import { declensionFactory } from '@helpers/declension';
import { formatDayWeek } from '@sharedHelpers/formatDate';

import styles from './shortInfoRecordUser.module.scss';

const recordValue = declensionFactory('запись', 'записи', 'записей');

export const ShortInfoRecordUser = () => {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const listRecordUser = useAppSelector(getRecordService);
  const isLoaded = useAppSelector(getIsLoadedUserRecord);
  const firstRecord = listRecordUser?.length && listRecordUser[0];
  const isError = useAppSelector(getIsErrorUserRecord);
  const isMobile = useWindowSizing(990);

  useEffect(() => {
    if (!isLoaded) {
      dispatch(fetchGetRecordsTireFitting());
    }
  }, []);

  const handlerRoute = useCallback(async () => {
    await router.push('/personal/records/');
  }, []);

  const handlerRouteMobile = useCallback(async () => {
    isMobile && (await router.push('/personal/records/'));
  }, [isMobile]);

  if (isError) {
    return (
      <WrapperLk className={styles.Wrapper} IsMobile={isMobile}>
        <div className={styles.Container}>
          <div className={styles.Title} onClick={handlerRoute}>
            Записи на услуги
            <IconChevronRight width={16} height={16} />
          </div>
          <WrapperErrorLkShort error={isError} />
        </div>
      </WrapperLk>
    );
  }

  if (!isLoaded) {
    return <SkeletonLoading className={styles.WrapperSkeleton} width={'100%'} height={'100%'} />;
  }

  if (isLoaded && !listRecordUser?.length) {
    return (
      <WrapperLk className={styles.Wrapper} IsMobile={isMobile} onClick={handlerRouteMobile}>
        <div className={styles.Container}>
          <div className={styles.Title} onClick={handlerRoute}>
            Записи на услуги
            <IconChevronRight width={16} height={16} />
          </div>
          <div className={styles.RecordDate}>Пока нет записей на услуги</div>
        </div>
        <MyLink href={'/rec/?widgetOpened'}>
          <Button id="btn-personal-order" size={ButtonSize.S} themes={ButtonThemes.DarkViolet}>
            Записаться
          </Button>
        </MyLink>
      </WrapperLk>
    );
  }

  return (
    <WrapperLk className={styles.Wrapper} IsMobile={isMobile} onClick={handlerRouteMobile}>
      <div className={styles.Container}>
        <div className={styles.Title} onClick={handlerRoute}>
          Записи на услуги
          <IconChevronRight width={16} height={16} />
        </div>
        <div className={styles.TypeService}>{!firstRecord.service ? 'Шиномонтаж' : 'Автосервис'}</div>
        <div className={styles.RecordDate}>
          <span>{`${firstRecord?.date?.textTime}, ${formatDayWeek(firstRecord?.date?.textTime)}`}</span>
          <Badge theme={BadgeTheme.Yellow}>{firstRecord?.date?.time}</Badge>
        </div>
        <div className={styles.OrderPrice}></div>
      </div>
      {listRecordUser?.length > 1 && (
        <Badge className={styles.Badge} onClick={handlerRoute}>
          +{listRecordUser?.length - 1}
          <span>{recordValue(listRecordUser?.length - 1)}</span>
          <IconChevronRight width={16} height={16} />
        </Badge>
      )}
    </WrapperLk>
  );
};
